import AdminSearchFiltersComponent from './AdminSearchFilters/AdminSearchFilters'

export const AdminSearchFilters = AdminSearchFiltersComponent
